import { Link } from "react-router";
import React, { Component } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { logout, getStorage } from "./CustomComponent.js"
import { Modal } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/index.css";
import "../assets/css/sidebar.css";
import "./global.js";

export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: false,
      modal_logout: false,
    };
  }
  componentDidMount() { 
  }
  icon = (icon) => { return (<label className="icon">{icon}</label>) }
  active = (path) => { return window.location.pathname.includes(path) }
  render() {
    return (
      <div>
        <div className="w-100 px-0 position-fixed d-flex justify-content-between bg-primary shadow px-4 py-2 body" style={{ height: 60, zIndex: 1010 }}>
          <div className="d-flex align-items-center">
            {this.props.sidebar !== "false" && (
              <label className="d-block d-lg-none d-xl-none me-3" onClick={() => { this.setState({ sidebar: !this.state.sidebar }); }}>
                <span className="icon text-white text-18 pointer">{"\uf0c9"}</span>
              </label>
            )}
            {/* <div className="position-relative">
              <h3><b>S.K.SERVICE</b></h3>
              <small className="position-absolute" style={{ right: 0, bottom: -5 }}> {global.version}</small>
            </div> */}
            <div className="d-none d-sm-none d-md-flex d-lg-flex d-xl-flex text-white">
              <small>{this.props.page1}</small>
              <small className="ms-2">{this.props.page2 ? " > " + this.props.page2 : ""}</small>
              <small className="ms-2">{this.props.page3 ? " > " + this.props.page3 : ""}</small>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            {(getStorage("user") && !getStorage("user").branch_id) && (
              <button className="btn btn-orange me-3 px-3" onClick={() => { window.location.href = "/console" }}><span className="icon me-2">{"\uf2f1"}</span>สลับกิจการ</button>
            )}
            <div className="ps-3" style={{ borderLeftStyle: "solid", borderLeftWidth: 1, borderLeftColor: "#ffffff" }}>
              <span className="me-2 align-items-center d-none d-sm-flex d-md-flex d-lg-flex d-xl-flex text-white">
                ชื่อ : {getStorage("user") ? getStorage("user").full_name : "-"}
              </span>
              <small className="me-2 align-items-center d-none d-sm-flex d-md-flex d-lg-flex d-xl-flex text-white">
                อีเมล : {getStorage("user") ? getStorage("user").email : "-"} สาขา : {getStorage("branch") ? getStorage("branch").branch_name : "-"}
              </small>
            </div>
            <div className="wpx-40 hpx-40 rounded-circle bg-secondary">
              <img src={LOGO} style={{ width: 40 }} />
            </div>
            <label className="icon text-18 p-2 text-white pointer" onClick={() => { this.setState({ modal_logout: true }) }}>{"\uf2f5"}</label>
          </div>
        </div>

        {/* MENU */}
        {this.props.sidebar !== "false" &&(
        <ProSidebar className="full-screen pt-0" breakPoint="lg" toggled={this.state.sidebar} onFocus={() => { this.setState({ sidebar: true }); }}>
          <div className="d-flex justify-content-center pt-2">
            <img src={LOGO} style={{ width: 170 }} />
          </div>
          <div className="w-100 text-center mb-3">
            <small className="text-secondary">{global.version}</small>
          </div>
          <Menu className="overflow-scroll none-scroll sidebar-h">
            <MenuItem icon={this.icon("\uf627")} active={this.active("/dashboard")}><Link to="/dashboard">หน้าหลัก</Link></MenuItem>
            <SubMenu icon={this.icon("\uf627")} title="จัดการงานซ่อม"
              defaultOpen={window.location.pathname.includes("/manage-repair/")}>
              <MenuItem active={window.location.pathname === "/manage-repair/repair/create"}><Link to="/manage-repair/repair/create">แจ้งซ่อม</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/manage-repair/list-repair"}><Link to="/manage-repair/list-repair">จัดการแจ้งซ่อม</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/manage-repair/calendar-repair"}><Link to="/manage-repair/calendar-repair">ปฏิทินแจ้งซ่อม</Link></MenuItem>
            </SubMenu>
            <SubMenu icon={this.icon("\uf627")} title="ระบบขาย"
              defaultOpen={window.location.pathname.includes("/sale/")}>
              <MenuItem active={window.location.pathname === "/sale/sale/create"}><Link to="/sale/sale/create">ระบบชำระเงิน</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/sale/list-sale"}><Link to="/sale/list-sale">รายการชำระเงิน</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/sale/list-quotation"}><Link to="/sale/list-quotation">ใบเสนอราคา</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/sale/list-billing"}><Link to="/sale/list-billing">ใบวางบิล</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/sale/list-invoice"}><Link to="/sale/list-invoice">ใบแจ้งหนี้</Link></MenuItem>
            </SubMenu>
            <SubMenu icon={this.icon("\uf627")} title="ระบบสั่งซื้อ"
              defaultOpen={window.location.pathname.includes("/order/")}>
              <MenuItem active={window.location.pathname === "/order/list-approve-order"}><Link to="/order/list-approve-order">บันทึกรออนุมัติสั่งซื้อ</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/order/list-order"}><Link to="/order/list-order">ใบสั่งซื้อ</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/order/list-receipt"}><Link to="/order/list-receipt">ใบรับสินค้า</Link></MenuItem>
            </SubMenu>
            <SubMenu icon={this.icon("\uf627")} title="จัดการสต๊อก"
              defaultOpen={window.location.pathname.includes("/stock/")}>
              <MenuItem active={window.location.pathname === "/stock/list-spare-parts"}><Link to="/stock/list-spare-parts">เบิกอะไหล่</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/stock/list-stock"}><Link to="/stock/list-stock">สต๊อกสินค้า</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/stock/list-stock-history"}><Link to="/stock/list-stock-history">ประวัติสต๊อก</Link></MenuItem>
            </SubMenu>
            <SubMenu icon={this.icon("\uf627")} title="รายงาน"
              defaultOpen={window.location.pathname.includes("/report/")}>
              <MenuItem active={window.location.pathname === "/report/repair"}><Link to="/report/repair">รายงานจัดการงานซ่อม</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/receipt"}><Link to="/report/receipt">รายงานใบเสร็จรับเงิน</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/billing"}><Link to="/report/billing">รายงานใบวางบิล</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/stock"}><Link to="/report/stock">รายงานสต๊อกคงคลัง</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/spare-parts"}><Link to="/report/spare-parts">รายงานเบิกอะไหล่</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/recieve-spare-parts"}><Link to="/report/recieve-spare-parts">รายงานรับอะไหล่</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/spare-parts-minimal"}><Link to="/report/spare-parts-minimal">รายงานการรับสินค้าแบบผลรวม</Link></MenuItem>
              <MenuItem active={window.location.pathname === "/report/inssure-part"}><Link to="/report/inssure-part">รายงานเบิกสินค้าแบบผลรวม</Link></MenuItem>
            </SubMenu>
            <MenuItem icon={this.icon("\uf627")} active={this.active("/log")}><Link to="/log">Log</Link></MenuItem>
            <MenuItem icon={this.icon("\uf627")} active={this.active("/master")}><Link to="/master">จัดการระบบ</Link></MenuItem>
          </Menu>
        </ProSidebar>
        )}
        {/* MODAL */}
        <Modal show={this.state.modal_logout} onHide={() => { this.setState({ modal_logout: false }) }}>
          <Modal.Header><Modal.Title><b>ออกจากระบบ</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100  mb-3">
              <label>ยืนยันการออกจากระบบหรือไม่</label>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="w-100 d-flex">
              <div className="w-50 pe-1">
                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_logout: false }) }}>ยกเลิก</button>
              </div>
              <div className="w-50 ps-1">
                <button className="btn btn-orange w-100" onClick={() => { logout() }}>ออกจากระบบ</button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div >
    );
  }
} 